import { PressureOptKey } from "components/containers/inspectionSetting/containers/templateBuilder/fields/device-pressure/previewer";
import Peripheral from "./BasePeripheral";

export enum SupportHandlers {
  requestDeviceDataAtNeptune = "requestDeviceDataAtNeptune",
  requestPhotoDataAtNeptune = "requestPhotoDataAtNeptune",
}

export enum ERRORS {
  CANNOT_CONNECT = "CANNOT_CONNECT",
  NO_RESPONSE = "NO_RESPONSE",
  CANCEL_REQUEST = "CANCEL_REQUEST",
}

export interface PeripheralResponse<T = any> {
  data: T;
  identify_info: string;
}

export type PhotoResponse = PeripheralResponse<null | File>;

export type PressureResponse = PeripheralResponse<PressureValue>;

export const formatDate = "YYYY/MM/DD HH:mm:ss";

export enum ReceivedDeviceType {
  PRESSURE = "pressure",
}

/**
 * Example:
 * {
 *    "type": "1",
 *    "identify_info": "Base64 encoded",
 *    "result": {
 *        "start_date": 1723939205,
 *        "start_value": "10MPa",
 *        "end_date": 1729159942,
 *        "end_value": "15MPa"
 *    }
 * }
 */
export interface ReceiveDataResponse {
  type: string;
  identify_info: string;
  result: {
    start_date: number;
    start_value: string;
    end_date: number;
    end_value: string;
  };
}

export interface PressureValue {
  [PressureOptKey.START_DATE]: string;
  [PressureOptKey.START_VALUE]: string;
  [PressureOptKey.END_DATE]: string;
  [PressureOptKey.END_VALUE]: string;
}

export function initPeripheralConnection() {
  Peripheral.register(
    "receiveDeviceDataAtNeptune",
    SupportHandlers.requestDeviceDataAtNeptune
  );

  Peripheral.register(
    "receivePhotoDataAtNeptune",
    SupportHandlers.requestPhotoDataAtNeptune
  );
}

export type Listener<T = any> = (data: T) => void;

export enum PeripheralType {
  CAMERA = "camera",
  PRESSURE = "pressure",
}
